import aboutPageTranslations from 'src/i18n/en-US/aboutPage';
import congratulationsPage from 'src/i18n/en-US/congratulationsPage';
import deleteAccountPage from 'src/i18n/en-US/deleteAccountPage';
import donationsPageTranslations from 'src/i18n/en-US/donationsPage';
import homePageTranslations from 'src/i18n/en-US/homePage';
import onboardingPage from 'src/i18n/en-US/onboardingPage';
import privacyPolicyPage from 'src/i18n/en-US/privacyPolicy';
import termsPage from 'src/i18n/en-US/terms';
import uninstallPage from 'src/i18n/en-US/uninstallPage';

export default {
  // General translations start here
  relatedSearch: 'Related searches to "{keyword}"',
  animalsHelped: 'animals helped',
  submit: 'submit',
  allRightsReserved: 'All rights reserved.',
  signupMsg: 'Please check your email for your login link.',
  makeCheerieDefault: 'Make Cheerie your default search engine.',
  feedback: 'Feedback',
  emailContactMsg: 'Drop us a line via email',
  searchNumberMsg: `This is the number of searches you have performed with
                  Cheerie. On average you need around 45 searches to help one
                  animal!`,
  searchNow: 'Search now',
  home: 'Home',
  signUp: 'Sign Up',
  about: 'About',
  donationReports: 'Donation reports',
  terms: 'Terms',
  deleteAccount: 'Delete Account',
  privacy: 'Privacy',
  logOut: 'Log out',
  searchCounter: 'Search Counter',
  continue: 'continue',
  numberOfSearches:
    'This is the number of searches you have performed with Cheerie.',
  averageSearches: 'On average you need around 45 searches to help one animal!',
  saveAnimalsEngine: 'The search engine that saves animals',
  noInternetConnection: 'You are not connected to the Internet',
  downloadFor: 'Download for {platform}',
  addCheerieTo: "Add to {platform} - It's free",
  shareCheerie: 'Share Cheerie',
  somethingIsWrong: 'Something is wrong',
  pageNotFoundMsg:
    'The page you are looking for was moved, removed, renamed, or might never existed!',
  backToHome: 'Back To Home',
  bestFriends: 'Best Friends',
  backMsg: 'Go back',
  oops: 'Oops...',
  aboutUs: 'About Us',
  contactForm: {
    title: 'Contact us',
    name: 'Your Name',
    required: 'This field is required.',
    email: 'Email Address',
    message: 'Message',
    send: 'Send Message',
  },
  locatedMsg: 'We are located here',
  signUpHeader: 'Sign up and keep track of your impact!',
  checkMail: 'Check your email!',
  validEmail: 'Your valid email address ...',
  enterMail: 'Enter your email and we’ll send you a link to sign up',
  mailSent: 'We’ve just sent a link to your email address',
  yourEmail: 'Your email address',
  noMailReceived: 'Didn’t get an email?',
  resend: 'Resend',
  continueToCheerie: 'Continue to Cheerie',
  next: 'Next',
  skip: 'Skip',
  searchToSaveAnimals: 'Start searching to save animals',
  pl3: {
    heading: 'The search engine that saves animals',
    p: 'Make a change. Support no kill shelters. 100% free for you.',
    msg: 'Thousands+ of users worldwide',
  },
  relatedTopics: 'Related search topics for {keyword}',
  noRelatedTopics: 'No related topics for {keyword}',

  // Page specific translations
  homePage: homePageTranslations,
  donationsPage: donationsPageTranslations,
  aboutPage: aboutPageTranslations,
  privacyPolicy: privacyPolicyPage,
  termsPage: termsPage,
  congratulationsPage,
  uninstallPage: uninstallPage,
  onboardingPage: onboardingPage,
  deleteAccountPage: deleteAccountPage,
};
